import { Kitchen } from '@rta/rta-blueprint-library';

// FNV-1a 32-bit hash — deterministic, dependency-free
const hashString = (input: string): string => {
	let hash = 0x811c9dc5;
	for (let i = 0; i < input.length; i++) {
		hash ^= input.charCodeAt(i);
		hash = Math.imul(hash, 0x01000193);
	}
	return (hash >>> 0).toString(16);
};

/**
 * Signature of the kitchen's VISUAL state (geometry + materials only) — excludes pricing,
 * promos, notes and design details so non-visual edits never falsely flag a rendering stale.
 * Changes exactly when the 3D render would look different.
 */
export const getKitchenRenderSignature = (kitchen: Kitchen | null): string => {
	if (!kitchen) return '';
	const data = kitchen.serialize();
	return hashString(JSON.stringify({ design: data.design, material: data.material }));
};
